<template>
  <!-- Model Preview-->
  <div
    class="modal fade p-0"
    id="imagemodal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-on:keyup="keyHandler($event)"
  >
    <div class="modal-dialog ">
<!--    <div class="modal-dialog col-10 pl-0 pr-0 mt-1">-->
      <div class="spinner-cover" style="display: block;">
        <div class="spinner"></div>
      </div>
      <div class="modal-content PhotoXXL">
        <div class="modal-header">
          Foto-Nr. {{currentModalPhoto.runid}} - {{currentModalPhoto.photodate_c | getDateString()}} {{ currentModalPhoto.photodate_c | getTimeString() }} Uhr
          <button type="button" class="close" data-dismiss="modal" style="position: absolute; top:8px; right: 8px;">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
        </div>
        <div class="modal-body">

          <div class="" :class="{'gridcontainer expanded': viewmode === 'full', 'gridcontainer': viewmode !== 'full'}">
            <div class="box box1 pos-rel" id="xxl_canvas_div">
<!--              <div  class="canvas_div" style="height:100%; width:100%; margin-left: 0; margin-right:0; border-radius: 10px; border: 1px solid #cccccc; overflow: hidden;">-->
                <!--                <canvas ref="xxlcanvas" id="canvass"></canvas>-->


<!--              <div :id="`xxl_viewer_`+imagedetails.pdphotoid" ref="viewerContainer" v-if="imagedetails">-->

                <div id="xxl_viewer_virtual" ref="viewerContainer" style="width:100%; height:100%;"></div>
                <canvas ref="previewcanvas" id="previewcanvas"></canvas>


                <a href="#" @click="toLeft" v-if="!hideImageShift" style="position: absolute; right: 45px; bottom: 10px; width: 20px; height:20px; z-index:500;">
                  <img  src="@/assets/images/pdarrow_left.png" class="XXL_view_left_arrow" alt="prev-image" style="width:20px; height: 20px; right: auto; top: auto; position: relative; left:auto;"/>
                </a>
                <a href="#" @click="toRight" v-if="!hideImageShift" style="position: absolute; right: 20px; bottom: 10px; width: 20px; height:20px; z-index:500;">
                  <img src="@/assets/images/pdarrow_right.png" class="XXL_view_right_arrow" alt="next-image" style="width:20px; height: 20px; right: auto; top: auto; position: relative; left:auto;"/>
                </a>
<!--              </div>-->

              <span class="setmode" @click="toggleViewMode" style="position: absolute; top:10px; left:10px; z-index:500;">
                <i class="fa fa-image" v-if="viewmode != 'full'"></i>
                <i class="fa fa-file-text" v-if="viewmode == 'full'"></i>
              </span>


            </div>
            <div class="box box2 pos-rel" id="cutout">
                <canvas ref="cutoutcanvas" id="cutoutcanvas" ></canvas>
                <ul class="cutoutlist" style="position:absolute; top:1px; left:35px; list-style: none; padding: 0; margin: 0;">
                  <li v-for="cutout in cutoffs"
                      style="display:inline-block; margin-right:10px; border: 1px solid #ccc; padding:3px 8px; border-top:0; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; background: #FFF;"
                      :class="{'cutout-active': cutout.bactive}"
                      @click="setCutoutImage(cutout)">{{ cutout.description }}</li>
                </ul>
                <div class="" v-if="cutoffs.length <= 0" style="position: absolute; top: 45%; left:50%; transform: translate(-50%, -50%); text-align: center;">
                  Kein Ausschnitt vorhanden.
                </div>
            </div>
            <div class="box box3 p-1">
              <div class="font-bold mb-1">Beschreibung</div>
              {{currentModalPhoto.description}}
            </div>
            <div class="box box4 p-1">
              <div class="row">
                <div class="col-sm-6">
                  <div class="font-bold mb-1">Informationen</div>
                  <ul>
                    <li class="mb-1" v-if="cutoffs.length > 0"><span class="font-bold">Plan:</span>
                      <span v-for="(cutout, index) in cutoffs">
                        {{cutout.description}}<span v-if="index < cutoffs.length - 1">, </span>
                      </span>
                    </li>
                    <li class="mb-1" v-if="imagedetails != null"><span class="font-bold">Datum:</span> {{imagedetails.photodate | getDateString() }}</li>
                    <li class="mb-1" v-if="imagedetails != null"><span class="font-bold">Uhrzeit:</span> {{ imagedetails.photodate | getTimeString() }} Uhr</li>
                    <li class="mb-1" v-if="imagedetails != null"><span class="font-bold">Ersteller:</span> {{ imagedetails.firstname }} {{imagedetails.lastname}}</li>
                  </ul>
                </div>
                <div class="col-sm-6">
                  <div class="font-bold mb-1">Schlagworte</div>
                  <ul v-if="imagedetails">
                    <li v-for="(tagitem, index) in groupedTags" :key="index" class="mb-1">
                      <span class="font-bold">{{ tagitem.key }}: </span>
                      <span v-if="tagitem.keytype == 0" v-for="(tagitem2, index2) in tagitem.items" :key="index2">
                          {{ tagitem2.name }}<span v-if="index2 < tagitem.items.length - 1">, </span></span>

                      <div v-for="(tagitem2, index2) in tagitem.items" v-if="tagitem.keytype == 1">
                        <span v-if="tagitem2.name != ''">- {{ tagitem2.name }}:</span>
                        <span v-if="tagitem2.value === true">Ja</span>
                        <span v-else-if="tagitem2.value === false">Nein</span>
                        <span v-else>{{ tagitem2.value }}</span>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- Model Preview END-->
</template>

<style scoped>

.modal-dialog {
  width:99%;
  height:99%;
  margin: 0.5%;
  margin-bottom:0;
}

.modal-content {
  height:99%;
  width:99%;
  margin: auto !important;
}

.modal-content.PhotoXXL {
  height:99%;
  width:99%;
  margin: auto !important;
}

.modal-header {
  font-size: 1rem;
  color: white;
  font-weight:bold;
  background: rgba(26, 35, 25, 0.8);
  padding: 0.5rem;
}

.modal-header .close {
  color: white;
}

.cutout-active {
  background: #39F !important;
  color: white;
}

 .gridcontainer {
   display: grid;
   grid-template-rows: 75% auto;
   grid-template-columns: repeat(2, 1fr);
   gap: 20px;
   height: 100%;
 }

 .box {/* Box-Farbe zur Ansicht */
   overflow: hidden;
   border-radius: 10px;
   border: 1px solid #cccccc;
 }

.box1 {
  grid-row: 1; /* erste Zeile */
  grid-column: 1; /* erste Spalte */
}

.box2 {
  grid-row: 1; /* erste Zeile */
  grid-column: 2; /* zweite Spalte */
}

.box3 {
  grid-row: 2; /* zweite Zeile */
  grid-column: 1; /* erste Spalte */
}

.box4 {
  grid-row: 2; /* zweite Zeile */
  grid-column: 2; /* zweite Spalte */
}

/* Zustand, bei dem nur Box 1 sichtbar ist */
.gridcontainer.expanded {
  grid-template-rows: 100%; /* Eine Zeile, die 100% des Containers einnimmt */
  grid-template-columns: 100%; /* Eine Spalte mit voller Breite */
}

.gridcontainer.expanded .box1 {
  grid-row: 1; /* Erstes Element immer in der ersten Zeile */
  grid-column: 1; /* Erstes Element immer in der ersten Spalte */
}

.gridcontainer.expanded .box2,
.gridcontainer.expanded .box3,
.gridcontainer.expanded .box4 {
  display: none; /* Box 2, 3 und 4 ausblenden */
}


</style>


<script>
import Main from '../photo/components/Main'
import moment from 'moment'
import {mapState} from 'vuex'
import {fabric} from 'fabric'
import axios from '../../utils/axiosinstance'

import {Viewer} from 'photo-sphere-viewer';
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'

// import axios from 'axios'
export default {
  name: "PhotoModal",
  filters: {
    toDEDate: function(datestring) {
      if(!datestring ||datestring == undefined) return ''

      return moment(datestring).format('DD.MM.YYYY HH:mm:ss')
    },
    getDateString: function(datestring) {
      if(!datestring ||datestring == undefined) return ''

      return moment(datestring).format('DD.MM.YYYY')
    },
    getTimeString: function(datestring) {
      if(!datestring ||datestring == undefined) return ''

      return moment(datestring).format('HH:mm:ss')
    }
  },

  props: ["photoIDCollection",'imgSrc'],
  data() {
    return {
      lastX: null,
      lastY: null,
      PhotoID_Array:[],
      photo: [],
      currentphoto: {pdphotoid: 0},
      imageSrc: '',
      canvasref: null,
      canvas: null,
      zoom_value: 3,
      zoomRange: 10,
      zoomLevel: 10,
      hideImageShift: false,

      inplans: '',
      cutoffs: [],

      cutoutimage: null,
      ctxcutout: null,
      COscale: 1,
      COposX: 0,
      COposY: 0,
      COoriginalWidth: 0,
      COoriginalHeight: 0,
      COzoomListenerAdded: false,
      COisDragging: false,
      COdragStartX: 0,
      COdragStartY: 0,
      COminScale: 0,
      COmaxScale: 5,

      viewmode: 'grid',
      previewCanvas: null,
      imagedetails: null,

      viewer: null,
      virtualcontainer: null
    }
  },
  created: function () {
    this.photoArray = this.photo
  },
  computed: {
    ...mapState({
      currentModalPhoto: state => state.photo.currentModalPhoto
    }),
    currentPhotoId () {
      return this.currentModalPhoto.pdphotoid
    },
    currentPhotoIsVirtual () {
      return this.currentModalPhoto.phototype == '360'
    },
    groupedTags() {
      // Gruppieren nach 'group'
      const grouped = this.imagedetails.params.reduce((acc, item) => {
          if (!acc[item.group]) {
            acc[item.group] = {
              key: item.group,
              keytype: item.type,
              items: []
            };
          }

          // Prüfen, wie der Wert interpretiert werden soll (type 0 oder type 1)
          const value = item.type === 0
            ? (item.value === "1") // Wenn type = 1, dann true/false
            : item.value;          // Wenn type = 0, dann den Stringwert behalten

          acc[item.group].items.push({
            name: item.name, // Name des Elements
            value: value     // Angepasster Value
          });

          return acc;
        }, {});

        // In Array umwandeln
        return Object.values(grouped);

      }

  },

  methods:{

    toggleViewMode() {
      // Modus wechseln
      this.viewmode = this.viewmode === 'full' ? 'default' : 'full';

      // Canvas neu berechnen
      this.$nextTick(() => {
        this.recalculateCanvas();
        if(this.$store.state.photo.currentModalPhoto.phototype == '360') {
          this.getVirtualImageXXL(this.$store.state.photo.currentModalPhoto)
        } else {
          this.getfileImage_xxl(this.$store.state.photo.currentModalPhoto)
        }
      });

    },
    recalculateCanvas() {
      // Zugriff auf das Canvas-Element mit `ref`
      // const canvas = this.$refs.previewcanvas;

      if (this.previewCanvas) {
        const element = document.getElementById("xxl_canvas_div");

        // Skalierung oder Neupositionierung hier implementieren
        const width = element.offsetWidth;
        const height = element.offsetHeight;


        this.previewCanvas.setWidth(width);
        this.previewCanvas.setHeight(height);


        console.log('Recalc Params',
          element.offsetWidth,
          element.offsetHeight)

        // Beispielzeichnung für Testzwecke
        console.log('Canvas wurde neu berechnet.');
      }
    },


    async loadxxl(photo) {
      let _this = this

      console.log('Run loadxxl Image - ', photo)

      $('#imagemodal').modal('show')
      if (!(this.canvas === null || this.canvas === undefined)) {
        this.canvas.clear()
        this.canvas.dispose()
      }

      if(this.viewer != null) {
        this.viewer.destroy()
        this.viewer = null
        console.log('Viewer Destroyed')
      }

      this.canvas = _this.createCanvas()

      $('.spinner-cover').show()
      this.$store.state.photo.currentModalPhoto = photo

      const isBase64 = typeof photo === 'string' && photo.startsWith('data:image/');
      if (isBase64) {

        console.log('Image is Base64')
        _this.hideImageShift = true
        setTimeout(function () {
          let canvas = _this.canvas
          // Für Base64 -> Direkt ins Canvas laden
          const image = new Image();
          image.src = photo;

          image.onload = function () {
            const fabricImage = new fabric.Image(image);

            _this.zoom_value = 3
            _this.zoomRange = 10
            _this.zoomLevel = 10
            _this.zoomLevel = 0
            console.log('Bildbreite:', image.width);
            console.log('Bildhöhe:', image.height);

            // Set Canvas Size
            let hgt = document.querySelector('#xxl_canvas_div').offsetHeight
            let hPer = (hgt / image.height) * 100
            let width = (image.width / 100) * hPer
            let canvas_width = document.querySelector('#xxl_canvas_div').offsetWidth
            let hPerForOffset = (hgt / image.height) * 100
            let widthForOffset = (image.width / 100) * hPerForOffset
            _this.offset_left = (canvas_width - widthForOffset) / 2

            console.log('ImageProps', hgt, width, hPerForOffset, widthForOffset)

            canvas.setHeight(hgt)
            canvas.setWidth(width)

            console.log('XXLCanvas setBackground')
            canvas.setBackgroundImage(fabricImage, canvas.renderAll.bind(canvas), {
              centeredRotation: true,
              centeredScaling: true,
              originX: 'middle',
              originY: 'middle',
              backgroundImageStretch: true
            })

            fabricImage.set({
              centeredRotation: true,
              centeredScaling: true,
              originX: 'middle',
              originY: 'middle',
              scaleX: canvas.width / fabricImage.width,
              scaleY: canvas.height / fabricImage.height
            })

            console.log('XXLCanvas setWidth', canvas_width)
            canvas.setWidth(canvas_width)

            console.log('XXLCanvas centerObject', fabricImage)
            canvas.centerObject(fabricImage)
            // _this.canvas = canvas

            console.log('XXLCanvas render')
            canvas.renderAll()






            _this.setEventsOnCanvas(canvas)
            $('.spinner-cover').hide();
          }

        }, 1000)


      } else {

        console.log('XXL Call is photo Object', photo)

        _this.hideImageShift = false
        if(_this.currentModalPhoto.phototype == '360') {
          setTimeout(function () {
            _this.getVirtualImageXXL(_this.currentModalPhoto)
            $('.spinner-cover').hide()
          }, 1000)
        } else {
          // Short duration needed to setup canvas full
          setTimeout(function () {
            _this.getfileImage_xxl(_this.currentModalPhoto)
            $('.spinner-cover').hide()
          }, 1000)
        }
      }
    },

    async getVirtualImageXXL(photo) {
      console.log('IS 360° IMage', photo)

      if(this.viewer != null) {
        this.viewer.destroy()
        this.viewer = null
        console.log('Viewer Destroyed')
      }

      this.$store.state.photo.currentModalPhoto = photo

      if(this.virtualcontainer == null) {
        this.virtualcontainer = document.getElementById('xxl_viewer_virtual')
      }

      document.getElementById('previewcanvas').style.display = 'none';
      document.getElementById('xxl_viewer_virtual').style.display = 'block';
      // document.getElementById('deinDivId').style.display = 'none';


      const jwt = localStorage.getItem('jwt')
      let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.projectid}&id=${photo.pdphotoid}&type=orig&token=${jwt}`

      console.log('Container', this.virtualcontainer, url, photo)

      this.viewer = new Viewer({
        container: this.virtualcontainer,
        panorama: url,
        navbar: ['zoom', 'move', 'fullscreen'],
        autorotateSpeed: '1rpm',
        autorotateDelay: 1500
      })


      this.getPreviewFotoDetails(photo)

      this.getCutouts(photo)

      $('.spinner-cover').hide();

    },


    async getfileImage_xxl (photo) {
      // process.env.VUE_APP_BASE_URL + "getfile/photo/" + photo_id + "/2000x2000/",

      let canvas = this.canvas


      document.getElementById('previewcanvas').style.display = 'block';
      document.getElementById('xxl_viewer_virtual').style.display = 'none';

      $('.spinner-cover').show();
      let _this = this
      this.$store.state.photo.currentModalPhoto = photo
      console.log('CurrentPhoto', this.currentphoto, photo)
      const jwt = localStorage.getItem('jwt')
      let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.projectid}&id=${photo.pdphotoid}&type=orig&token=${jwt}`
      await fetch(
        url,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onload = function() {
            let fotos = reader.result
            this.neuesBase = fotos
            _this.zoom_value = 3
            _this.zoomRange = 10
            _this.zoomLevel = 10
            _this.zoomLevel = 0
            _this.imageSrc = fotos

            // console.log('Current - Fotos', fotos)
            // _this.setPhotoInCanvas(fotos)

            _this.setPreview(fotos)

            _this.getPreviewFotoDetails(photo)

            _this.getCutouts(photo)

            // _this.setPhotoInCanvas(canvas , fotos)
            _this.setEventsOnCanvas(canvas)
            // _this.makeCanvas()
            $('.spinner-cover').hide();

            console.log('AfterLoad', _this);

            ///**Insert the ID and src to Image Tag  **/
            // $('.xxl_photo_view').prop('src', fotos)
            // $('.xxl_photo_view').prop('id', photo.pdphotoid)
          }
        })

    },

    setPreview(photo) {
      // Canvas = previewcanvas
      if (this.previewCanvas) {
        this.previewCanvas.dispose(); // Löscht die alte Canvas-Instanz korrekt
      }

      const canvasElement = this.$refs.previewcanvas;
      const parentDiv = canvasElement.parentElement;

      // Neues Fabric.js Canvas initialisieren
      this.previewCanvas = new fabric.Canvas(canvasElement);

      // Größe des Fabric.js Canvas einstellen
      this.previewCanvas.setWidth(parentDiv.clientWidth);
      this.previewCanvas.setHeight(parentDiv.clientHeight);

      fabric.Image.fromURL(photo, (img) => {
        // Proportionale Skalierung ermitteln
        const scaleWidth = this.previewCanvas.width / img.width; // Skalierung in der Breite
        const scaleHeight = this.previewCanvas.height / img.height; // Skalierung in der Höhe

        // Kleineren Wert wählen, um Bild voll in das Canvas zu bekommen
        const scaleFactor = Math.max(scaleWidth, scaleHeight);

        img.scale(scaleFactor); // Bild proportional skalieren


        // img.originX = 'center'; // Mittelpunkt als Ursprung
        // img.originY = 'center';
        // img.left = this.previewCanvas.width / 2;  // Positionieren in die Mitte
        // img.top = this.previewCanvas.height / 2;

        // Markierungen und Interaktivität deaktivieren
        img.selectable = false; // Verhindert Auswahl
        img.evented = false;    // Keine interaktiven Events erlauben (z. B. Drag-and-Drop)

        this.previewCanvas.setBackgroundImage(
          img,
          this.previewCanvas.renderAll.bind(this.previewCanvas), // Rendern des Canvas nachdem das Bild geladen ist
          {
            originX: 'center', // Mitte des Canvas
            originY: 'center',
            top: this.previewCanvas.height / 2, // Zentrieren
            left: this.previewCanvas.width / 2, // Zentrieren
          }
        );
      });

      // Zoom-Handling
      this.previewCanvas.on('mouse:wheel', (event) => {
        const delta = event.e.deltaY; // Mausrad-Bewegung
        let zoom = this.previewCanvas.getZoom();

        // Zoom-Faktor anpassen
        zoom *= 0.999 ** delta;

        // Begrenzungen für Zoom einstellen
        zoom = Math.max(0.5, Math.min(zoom, 5));
        const canvasCenter = new fabric.Point(this.previewCanvas.width / 2, this.previewCanvas.height / 2);
        const centerPoint = fabric.util.transformPoint(
          canvasCenter,
          this.previewCanvas.viewportTransform
        );

        // Zoom setzen und Canvas zur Bildmitte verschieben
        this.previewCanvas.zoomToPoint(centerPoint, zoom);

        event.e.preventDefault();
        event.e.stopPropagation();
      });

      // Dragging aktivieren: Hintergrund bewegen
      let isPanning = false;
      this.previewCanvas.on('mouse:down', () => {
        isPanning = true;
      });

      this.previewCanvas.on('mouse:move', (event) => {
        if (isPanning && event && event.e) {
          const delta = new fabric.Point(event.e.movementX, event.e.movementY);
          this.previewCanvas.relativePan(delta);
        }
      });

      this.previewCanvas.on('mouse:up', () => {
        isPanning = false;
      });

      // this.fabricCanvas.renderOnAddRemove = false; // Verhindert übermäßige Renderaufrufe
      this.previewCanvas.selection = false; // Keine Gruppenauswahl
      // this.fabricCanvas.backgroundVpt = false; // Hintergrund wird nicht verschoben


    },


    createCanvas () {
      console.log('Create Canvas')
      const ref = this.$refs.xxlcanvas
      return new fabric.Canvas(ref, {
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
        hasBorders: false,
        lockRotation: false,
        lockMovement: false,
        lockMovementY: false,
        lockMovementX: false,
        lockUniScaling: false,
        lockScalingY: false,
        lockScalingX: false,
        originX: 'middle',
        originY: 'middle',
        preserveObjectStacking: false,
        pointDragTrue: false,
        width: 0,
        height: 0
      })
    },

    // async setPhotoInCanvas (canvas , photo) {
    async setPhotoInCanvas (photo) {
      let _this = this
      let canvas = this.canvas

      console.log('setPhotoInCanvas', photo)

      await fabric.Image.fromURL(photo, function (img) {

        let canvasDiv = document.querySelector('#xxl_canvas_div')

        let hgt = canvasDiv.scrollHeight
        let wdt = canvasDiv.scrollWidth

        if(canvas.height == 0 || canvas.width == 0) {
          console.log(canvas.height, canvas.width, 'canvas height and width')
          canvas.setHeight(hgt);
          canvas.setWidth(wdt);
          canvasDiv.style.setProperty('height', hgt + 'px', 'important');
          canvasDiv.style.setProperty('width', wdt + 'px', 'important');
        } else {
          console.log('Canvas PROPS is defined', {
            'height': hgt,
            'width': wdt,
            'canvas.height': canvas.height,
            'canvas.width': canvas.width
          })
        }

        console.log('canvas height', canvas.height, 'width', canvas.width, wdt + 0, hgt + 0)

        let hPer = (hgt / img.height) * 100
        let width = (img.width / 100) * hPer

        // let canvas_width = document.querySelector('#xxl_canvas_div').offsetWidth
        let canvas_width = wdt
        let hPerForOffset = (hgt / img.height) * 100
        let widthForOffset = (img.width / 100) * hPerForOffset
        _this.offset_left = (canvas_width - widthForOffset) / 2


        // canvas.setHeight(hgt)
        // canvas.setWidth(wdt)
        canvas.setWidth(width)
        console.log('XXLCanvas setBackground', hgt, wdt)
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          backgroundImageStretch: true,
        })

        console.log('XXLCanvas img.set')
        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })

        //
        console.log('XXLCanvas setWidth')
        canvas.setWidth(canvas_width)

        console.log('XXLCanvas centerObject')
        canvas.centerObject(img)
        // _this.canvas = canvas

        console.log('XXLCanvas render')
        canvas.renderAll()
        //Add events on canvas
      });
    },

    getZoomArea() {

    },

    canvasZoomIn () {
      let obj = this
      console.log('Zoom Before In OBJ', obj)
      console.log('Zoom Before In', obj.zoomRange)
      this.getZoomArea(obj)

      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        obj.zoomRange += 10
      }

      // if (obj.zoomRange <= 1000) {
      //   obj.zoomRange = parseInt(obj.zoomRange) + 10
      // }
      console.log('Zoom After In', obj.zoomRange)
    },

    canvasZoomOut () {
      let obj = this
      console.log('Zoom Before Out OBJ', obj)
      console.log('Zoom Before Out', obj.zoomRange)
      this.getZoomArea(obj)

      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        obj.zoomRange -= 10
      }

      // if (obj.zoomRange >= -100) {
      //   obj.zoomRange = parseInt(obj.zoomRange) - 10
      // }
      console.log('Zoom After Out', obj.zoomRange)
    },
    //Set a Zoom Level
    setZoomLevel () {
      let obj = this
      let zoom = this.zoomRange
      if (zoom >= 0 && zoom <= 50) {
        obj.zoomLevel = 10
      }
      if (zoom >= 51 && zoom <= 100) {
        obj.zoomLevel = 9
      } else if (zoom >= 101 && zoom <= 150) {
        obj.zoomLevel = 8
      } else if (zoom >= 151 && zoom <= 160) {
        obj.zoomLevel = 7
      } else if (zoom >= 201 && zoom <= 220) {
        obj.zoomLevel = 6
      } else if (zoom >= 251 && zoom <= 270) {
        obj.zoomLevel = 5
      } else if (zoom >= 301 && zoom <= 320) {
        obj.zoomLevel = 4
      } else if (zoom >= 351 && zoom <= 370) {
        obj.zoomLevel = 3
      } else if (zoom >= 401 && zoom <= 430) {
        obj.zoomLevel = 2
      } else if (zoom >= 500 && zoom <= 550) {
        obj.zoomLevel = 1
      }
      console.log('ZL:', obj.zoomLevel)
    },

    async getfileImage_count (photo) {
      // process.env.VUE_APP_BASE_URL + "getfile/photo/" + photo + "/2000x2000/",
      let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.pdprojectid}&id=${photo.pdphotoid}&type=l&token=${localStorage.sessiontoken}`
      await fetch(
        url,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onload = function() {
            let fotos = reader.result
            this.neuesBase = fotos
            /** set src Attribute to PhotoView **/
            $('.xxl_photo_view').prop('src', fotos)
          }

        })

    },

    toRight(){
      // this.ScrollZoom($('#image_container'),4,0.5);
      $('.spinner-cover').show();
      // $('.xxl_photo_view').prop('src', '');


      // let current_photo_id =  $('.xxl_photo_view').attr('id')
      let current_photo_id = this.currentModalPhoto.pdphotoid
      let current_photo_index = this.photoIDCollection.findIndex((photo) => photo.pdphotoid == current_photo_id)
      let photo_id_next = this.photoIDCollection[current_photo_index+1];


      console.log('NextPhotoId', photo_id_next, current_photo_id)

      if (photo_id_next !== undefined){

        if(photo_id_next.phototype == '360') {
            this.getVirtualImageXXL(photo_id_next)
        } else {
          this.getfileImage_xxl(photo_id_next);
        }

        this.getCutouts(photo_id_next)
        this.getPreviewFotoDetails(photo_id_next)
        this.PhotoID_Array = [];
      }else{
        $('#imagemodal').modal('hide');
        $('.spinner-cover').hide();
        return false;
      }

    },

    toLeft(){
      // this.ScrollZoom($('#image_container'),4,0.5);
      $('.spinner-cover').show();
      // $('.xxl_photo_view').prop('src', '');

      // let current_photo_id =  $('.xxl_photo_view').attr('id')
      let current_photo_id =  this.currentModalPhoto.pdphotoid
      let current_photo_index = this.photoIDCollection.findIndex((photo) => photo.pdphotoid == current_photo_id)
      let photo_id_prev = this.photoIDCollection[current_photo_index-1];

      console.log('PrevPhotoId', photo_id_prev, current_photo_id)

      if(photo_id_prev !== undefined){

        if(photo_id_prev.phototype == '360') {
          this.getVirtualImageXXL(photo_id_prev)
        } else {
          this.getfileImage_xxl(photo_id_prev);
        }

        this.getCutouts(photo_id_prev)
        this.getPreviewFotoDetails(photo_id_prev)
        this.PhotoID_Array = [];
      }else{
        $('#imagemodal').modal('hide');
        $('.spinner-cover').hide();
        return false;
      }
    },
    /** Function for Keyboard **/
    keyHandler (event) {
      if(event.key=='ArrowLeft'){
        this.toLeft();
      }else if(event.key=='ArrowRight'){
        this.toRight();
      }
    },

    setEventsOnCanvas(canvas) {
      let obj = this

      canvas.on('mouse:wheel', function (opt) {
        if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
          (opt.e.deltaY > 0) ? obj.canvasZoomOut() : obj.canvasZoomIn()
        } else {
          if(obj.zoomRange > 1000) obj.zoomRange = 1000;
          if(obj.zoomRange < 0) obj.zoomRange = 0;
          // obj.zoomRange = 0
        }
      })

      canvas.on('mouse:down', function (e) {
        obj.panning = true
        obj.lastX = obj.lastY = null;
        if (!e.target) {
          //
        }
      })

      canvas.on('mouse:up', function (e) {
        obj.panning = false
        obj.lastX = obj.lastY = null;
        if (!e.target) {
          //
        }
      })

      canvas.on('object:moving', function () {
        // console.log('Canvas- MouseMoving', obj)
        obj.panning = false
        //
      })

      canvas.on('mouse:move', function (e) {
        if (obj.panning && e && e.e) {
          if (e.e.type === 'mousemove'){
            // console.log('Canvas- MouseMove', obj.panning, e, e.e)
            let delta = new fabric.Point(e.e.movementX, e.e.movementY)
            canvas.relativePan(delta)
            let canvasViewPort = canvas.viewportTransform

            let bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
            if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
              canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
            }
            let rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
            if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
              canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
            }
          }else {
            obj.touchMoveEvent(e.e.touches[0],canvas)
          }
        }
      })
    },

    touchMoveEvent(touch,canvas){
      if (this.lastX && this.lastY) {
        const delta = new fabric.Point(touch.clientX - this.lastX, touch.clientY - this.lastY)
        canvas.relativePan(delta)
        const canvasViewPort = canvas.viewportTransform

        const bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
        if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
          canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
        }
        const rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
        if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
          canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
        }
      }
      this.lastX = touch.clientX;
      this.lastY = touch.clientY;
    },

    async getCutouts(image) {

      let _this = this

      let cutout_div = document.getElementById('cutout')
      let cutoutcanvas = document.getElementById('cutoutcanvas')

      let hgt = cutout_div.scrollHeight
      let wdt = cutout_div.scrollWidth

      cutoutcanvas.style.setProperty('height', hgt + 'px', 'important');
      cutoutcanvas.style.setProperty('width', wdt + 'px', 'important');


      console.log('GetCutouts', image);

      let params = {
        "methodName": "getPhotoFlagImages",
        "parameters": [image.projectid, image.pdphotoid],
        "serviceName": "ProjectdocuService"
      }
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getPhotoFlagImages&token=` + localStorage.sessiontoken, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        if (response.status === 200) {
          console.log('Cutoffs response', response)
          if(response.data.length > 0) {
            _this.cutoffs = response.data
            _this.cutoffs.forEach((item) => {
              this.$set(item, 'bactive', false); // Vue erkennt hier die Änderung
            });

            // this.cutoutimage = _this.cutoffs[0]
            _this.setCutoutImage(_this.cutoffs[0])
          } else {
            _this.cutoffs = []
            _this.cutoutimage = null
          }
        }
      })



    },

    drawCutoutImageOnCanvas(base64Image) {
      // Existierendes Fabric.js Canvas entfernen
      if (this.fabricCanvas) {
        this.fabricCanvas.dispose(); // Löscht die alte Canvas-Instanz korrekt
      }

      const canvasElement = this.$refs.cutoutcanvas;
      const parentDiv = canvasElement.parentElement;

      // Canvas Dimensionen aktualisieren
      canvasElement.width = parentDiv.clientWidth;
      canvasElement.height = parentDiv.clientHeight;

      // Neues Fabric.js Canvas initialisieren
      this.fabricCanvas = new fabric.Canvas(canvasElement);

      // Größe des Fabric.js Canvas einstellen
      this.fabricCanvas.setWidth(parentDiv.clientWidth);
      this.fabricCanvas.setHeight(parentDiv.clientHeight);

      // Bild als Hintergrund setzen
      fabric.Image.fromURL(base64Image, (img) => {
        // Proportionale Skalierung ermitteln
        const scaleWidth = this.fabricCanvas.width / img.width; // Skalierung in der Breite
        const scaleHeight = this.fabricCanvas.height / img.height; // Skalierung in der Höhe

        // Kleineren Wert wählen, um Bild voll in das Canvas zu bekommen
        const scaleFactor = Math.min(scaleWidth, scaleHeight);

        img.scale(scaleFactor); // Bild proportional skalieren
        // Markierungen und Interaktivität deaktivieren
        img.selectable = false; // Verhindert Auswahl
        img.evented = false;    // Keine interaktiven Events erlauben (z. B. Drag-and-Drop)

        this.fabricCanvas.setBackgroundImage(
          img,
          this.fabricCanvas.renderAll.bind(this.fabricCanvas), // Rendern des Canvas nachdem das Bild geladen ist
          {
            originX: 'center', // Mitte des Canvas
            originY: 'center',
            top: this.fabricCanvas.height / 2, // Zentrieren
            left: this.fabricCanvas.width / 2, // Zentrieren
          }
        );
      });

      // Zoom-Handling
      this.fabricCanvas.on('mouse:wheel', (event) => {
        const delta = event.e.deltaY; // Mausrad-Bewegung
        let zoom = this.fabricCanvas.getZoom();

        // Zoom-Faktor anpassen
        zoom *= 0.999 ** delta;

        // Begrenzungen für Zoom einstellen
        zoom = Math.max(0.5, Math.min(zoom, 5));
        const canvasCenter = new fabric.Point(this.fabricCanvas.width / 2, this.fabricCanvas.height / 2);
        const centerPoint = fabric.util.transformPoint(
          canvasCenter,
          this.fabricCanvas.viewportTransform
        );

        // Zoom setzen und Canvas zur Bildmitte verschieben
        this.fabricCanvas.zoomToPoint(centerPoint, zoom);

        event.e.preventDefault();
        event.e.stopPropagation();
      });

      // Dragging aktivieren: Hintergrund bewegen
      let isPanning = false;
      this.fabricCanvas.on('mouse:down', () => {
        isPanning = true;
      });

      this.fabricCanvas.on('mouse:move', (event) => {
        if (isPanning && event && event.e) {
          const delta = new fabric.Point(event.e.movementX, event.e.movementY);
          this.fabricCanvas.relativePan(delta);
        }
      });

      this.fabricCanvas.on('mouse:up', () => {
        isPanning = false;
      });

      // this.fabricCanvas.renderOnAddRemove = false; // Verhindert übermäßige Renderaufrufe
      this.fabricCanvas.selection = false; // Keine Gruppenauswahl
      // this.fabricCanvas.backgroundVpt = false; // Hintergrund wird nicht verschoben

    },

    setCutoutImage(cutout) {


      this.cutoffs.forEach((item) => {
        item.bactive = false;
      });
      this.$set(cutout, 'bactive', true);

      console.log('SetCutoutIMage', this.cutoffs)

      this.cutoutimage = cutout
    },

    async getPreviewFotoDetails(image) {

      let _this = this
      // getPhotoDetails
      let params = {
        "methodName": "getPhotoDetails",
        "parameters": [image.projectid, image.pdphotoid],
        "serviceName": "ProjectdocuService"
      }
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getPhotoDetails&token=` + localStorage.sessiontoken, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        if (response.status === 200) {


          if(response.data && Object.keys(response.data).length > 0) {
            console.log('Photodetails', response.data)
            _this.imagedetails = response.data
            // _this.$set(imagedetails, response.data, true);
          } else {
            _this.imagedetails = null
          }
        }
      })

    }


  },

  mounted() {
    // const canvas = this.$refs.cutoutcanvas;
    // this.ctxcutout = canvas.getContext("2d");
    console.log('XXL View Mounted!')
  },

  watch: {

    'cutoutimage': function(cutoutimage) {
      console.log('Cutout Image', cutoutimage)
      if (cutoutimage && cutoutimage.imagewithflag) {
        this.drawCutoutImageOnCanvas(cutoutimage.imagewithflag);
      }
      if(this.cutoffs.length <= 0) {
        if (this.fabricCanvas) {
          this.fabricCanvas.clear(); // Löscht den Inhalt des Canvas (keine Objekte mehr sichtbar)
          this.fabricCanvas.dispose(); // Räumt das alte Canvas korrekt auf
          this.fabricCanvas = null; // Setzt die Referenz zurück
        }

      }
    },

    'photo': function(photo) {
      console.log('SetCurrentPhoto', photo)
      this.currentphoto = photo
    },
    // Add Canvas
    'zoomRange': async function () {
      let obj = this
      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        let canvas = obj.canvas
        let c = (obj.zoomRange / 55) + 1
        canvas.zoomToPoint({x: canvas.getWidth() / 2, y: canvas.getHeight() / 2}, c)
        canvas.setZoom(c)
        await obj.canvas.getObjects().forEach(await function (point) {
          if (point.get('type') === 'group') {
            obj.setPointsZoom(obj.zoomRange, point)
          }
        })
        obj.imagesPopup = false
        obj.selectedFlagPhoto = null
        canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
        // Change The Zoom Level By Changing The Zoom
        obj.setZoomLevel()
      }
    },

    'zoomLevel': async function () {
      let obj = this
      let c = obj.canvas
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/PhotoModal.vue